import { render, staticRenderFns } from "./GiveRecord.vue?vue&type=template&id=772deb81&scoped=true"
import script from "./GiveRecord.vue?vue&type=script&lang=js"
export * from "./GiveRecord.vue?vue&type=script&lang=js"
import style0 from "./GiveRecord.vue?vue&type=style&index=0&id=772deb81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772deb81",
  null
  
)

export default component.exports